import { ApprovedAddress } from './approved-address.model';

export class ApprovedHousingSessionInformation {
    housingComplex: string;
    assignedApprovedAddresses: ApprovedAddress[];
}
